{
  "confirmDialog": {
    "no": "No",
    "yes": "Yes",
    "logoutTitle": "Do you really want to log out of your account?",
    "watchListTitle": "Are you sure you want to delete this ticker?",
    "confirmDeleteAll": "Are you sure you want to delete all widgets?",
    "confirmDeleteTemplate": "Are you sure you want to delete the template?",
    "confirmApplyTemplate": "You already have widgets. Do you want to replace them?",
    "delete": "Delete",
    "cancel": "Cancel",
    "apply": "Apply",
    "confirm": "Confirm"
  }
}
